var Currency = /** @class */ (function () {
    function Currency() {
    }
    Currency.getSymbol = function (isoCode) {
        switch (isoCode) {
            case 'EUR':
                return '&#x20ac;';
            case 'PLN':
                return '&#x7a;&#x142;';
            case 'CHF':
                return '&#x46;&#x72;&#x2e;';
            default:
                return '&#x20ac;';
        }
    };
    return Currency;
}());
export default Currency;
